<template>
  <div id="home" class="page">
    <h1>Party von ...</h1>
    <div id="foto_container">
      <div id="foto">
        <img src="../assets/img/ben-2018.jpeg">
      </div>
      <div id="kidsname">
          <p>{{party.kidsname}}</p>
      </div>
    </div>
    <div id="facts" v-if="party">
      <div id="mobile" class="fact">
        <p><a href="tel:01605189364">
          <i class="icon icon-mobile"></i>
          {{party.mobile}}</a></p>
      </div>
      <div id="email" class="fact">
        <p><a href="mailto:matthias@mertiens.de">
          <i class="icon icon-email"></i>
          {{party.email}}</a>
        </p>
      </div>
      <div id="date" class="fact">
        <p><i class="icon icon-date"></i>
        {{ party.partydate }}<br>
        {{ party.beginn }} - {{ party.end }} Uhr</p>
      </div>
      <div id="location" class="fact">
        <p><i class="icon icon-location"></i>
        {{ party.partylocation }}</p>
      </div>
    </div>
<!--
    <div id="video">
      <video controls >
        <source src="../assets/video/example-video.mp4" type="video/mp4">
        Dein Browser kann das Video leider nicht abspielen
      </video>
    </div>
-->
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import {db} from '../service/firebase';  
import { find } from 'lodash'
export default {
  name: 'Home',
  props: ['id'],
  components: {
  },
  firebase: {},
  data (){
    return {
      party: {
      },
    }
  },
  mounted() {
    //console.log( this.$store.state.currentParty )
  },
//  beforeCreate
  created (){
   this.$bindAsObject('party', db.ref('parties/' + this.$store.state.currentParty), null, function() { /* console.log('Ready fired!') */ } );
  }
}
</script>
<style>
  #foto_container { position: relative; top: 0; padding: .166666em 0 0 0; margin-bottom: .633333em; }
  #foto { margin: 0 auto; width: 8em; height: 8em; overflow: hidden; border: 5px solid #ffcc66; border-radius: 6em; }
  #foto img { display: block; width: 100%; max-width: 100%; }
  #kidsname { position: absolute; bottom: -1.0333em; left:0; right: 0; height: 3.433333333em; margin: 0 auto; padding: 0 0 0 0; background: url(../assets/img/bg_kidsname.svg) center center no-repeat; background-size: contain; }
  #kidsname p { font-size: 1.7333333rem; line-height: 1.3; color: #fff; font: 700; padding: 0.63333em; margin: 0; }
  #facts {
    padding: 0.933333em 0;
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .fact { padding: 0.933333em; border: 0 solid red; }
  .fact p { font-size: 1.1333rem; margin: 0; padding: 0 0 0.2222em 0;  }
  .icon { display: block; width: 3em; height: 3.83333em; border: 0 solid red; margin: 0 auto; }
  .icon-mobile { background: url(../assets/img/kigebu-icon-mobile.svg) center center no-repeat; background-size: contain; }
  .icon-email { background: url(../assets/img/kigebu-icon-mail.svg) center center no-repeat; background-size: contain; }
  .icon-date { background: url(../assets/img/kigebu-icon-date.svg) center center no-repeat; background-size: contain; }
  .icon-location { background: url(../assets/img/kigebu-icon-location.svg) center center no-repeat; background-size: contain; }
  #email p { word-wrap: break-word; }
  #video { display: block; max-width: 100%; margin: 1.433333em 2.866666em; padding: 0; border-radius: 1em; border: 5px solid #ffcc66 /* #369fb4 *//* #ffcc66 */; overflow: hidden; }
  video { max-width: 100%; padding: 0 !important; margin: 0 0 -0.38333em !important; border: 0 solid red; background: url(../assets/video/video-bg.png); background-size: cover; }
</style>
